<div class="wrapper">
  <div class="spinner">
      <mat-progress-spinner [color]="color" [mode]="mode" ></mat-progress-spinner>
  </div>
</div>
